import { render } from "./editNote.vue?vue&type=template&id=77c45fac"
import script from "./editNote.vue?vue&type=script&lang=js"
export * from "./editNote.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__